import { render, staticRenderFns } from "./chengpin.vue?vue&type=template&id=736d5e92&scoped=true&"
import script from "./chengpin.vue?vue&type=script&lang=js&"
export * from "./chengpin.vue?vue&type=script&lang=js&"
import style0 from "./chengpin.vue?vue&type=style&index=0&id=736d5e92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736d5e92",
  null
  
)

export default component.exports